import { render, staticRenderFns } from "./IconGpjkbjb.vue?vue&type=template&id=4eaa0c77"
import script from "./IconGpjkbjb.vue?vue&type=script&lang=js"
export * from "./IconGpjkbjb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports